<template>
	<div id="ClientWelcomePage" class="grey darken-4 main-content">
		<LeftNav/>
		<v-main>
			<v-container>
				<v-layout
					row
					wrap
					align-center
					justify-center
				>

				</v-layout>
			</v-container>
		</v-main>
	</div>
</template>

<script>
	export default {
		name: 'WelcomePage',
			data: () => ({
		})
	};
</script>

